export default {
  Btn_Common: {
    TuoZhuai: 'Drag',
    QueDing: 'Confirm',
    QuXiao: 'Cancel',
    XinZeng_ZhuanJieMa: 'Add promotion',
    XiuGai_ZhuanJieMa: 'Edit promotion',
    XinZeng_ShouQuan: 'Add authorization',
    XiuGai: 'Edit',
    Chufang_Yulan: 'Preview',
    DengRu: 'Sign in',
    ChaXun: 'Search',
    ChongZhi: 'Reset',
    XinZeng: 'Add',
    FenPei_JueSe: 'Roles',
    PaiBan_HaoYuan: 'Source',
    ChongZhi_MiMa: 'Reset password',
    QueRen: 'Confirm',
    GuanBi: 'Close',
    FuZhi: 'Copy',
    FuZhi_QuanBu: 'Copy all',
    ZhanTie: 'Paste',
    BaoCun: 'Save',
    YiSheng_Duan: 'Doctor terminal',
    XiuGai_ZhangHao_MiMa: 'Account&Password',
    TuiChu_DengLu: 'Log out',
    ShuaXin: 'Refresh',
    GuanBi_QiTa: 'Close others',
    GuanBi_SuoYou: 'Close all',
    XinZeng_JueSe: 'Add role',
    FenPei_QuanXian: 'Assign',
    ChaKan_QuanXian: 'View Permissions',
    ShanChu: 'Delete',
    XiuGai_JueSe: 'Edit role',
    XinZeng_YouHuiQuan: 'Add coupon',
    FaFang: 'Issue',
    PeiSong: 'Distribution',
    TianJia_DiZhi: 'Add address',
    XiaZai: 'Download',
    XinZeng_DingDan: 'Add order',
    ShenPi: 'Examine',
    QianShou: 'Signfor',
    WanJie: 'Complete',
    QianShou_JiLu: 'Signature record',
    ShenHe: 'Examine',
    XuanZe_YaoPin: 'Select medicine',
    QingKong_DingDan: 'Clear',
    ZanCun: 'Temporarily',
    TiJiao: 'Submit',
    Shang_Yi_Bu: 'Previous',
    QingChu: 'Clear',
    ShangChuan: 'Upload',
    YuLan: 'Preview',
    YuLan_Hou_TiJiao: 'Preview',
    XiuGai_MiMa: 'Edit password',
    XuanZe_XueWei: 'Select acupoints',
    XinZeng_YaoPin: 'Synchronous',
    TongBu: 'Synchronous',
    ShouFei_ZongJie: 'Charges',
    TongBu_GengXin: 'Update',
    XinZeng_ShangPin: 'Add product',
    XinZeng_BingRen: 'Add',
    XinZeng_TaoPiao: 'Add setmeal',
    TianRu: 'Fill in',
    QuanBu_XuanZhong: 'Select All',
    QuXiao_XuanZhong: 'Deselect All',
    ShengCheng_HaoYuan: 'Generate Slots',
    XinZeng_ZhenSuo: 'Add',
    XiuGai_ZhenSuo: 'Edit',
    PeiZhi: 'Configure',
    SouXun: 'Search',
    PiCi: 'Batch No.',
    XiuGai_YaoPin: 'Edit Medicine',
    YaoPin: 'Medicine',
    WanCheng: 'Completed',
    TianJia_ZuiXinJiLu: 'Add',
    BianJi_ZuiJinJiLu: 'Edit',
    FenPei: 'Allocate',
    JiaRu_ZhengZhen: 'Join',
    ZhengZhen: 'Add',
    QingKong_SuoYou_PaiBan: 'Clear',
    XinZeng_LuYou: 'Add',
    XiuXi: 'Rest',
    TianJia: 'Add',
    TianJia_ShiDuan: 'Add time slot',
    TianJia_FenZu: 'Add group',
    FaFang_QuanBu: 'Issue All',
    YanQi: 'Postpone',
    She_YouXiaoQi: 'Set Validity',
    YiXuan: 'Selected',
    QingKong: 'Clear',
    PaiBan_ShunXv: 'Scheduling Order',
    LiShi_PaiBan: 'History',
    FenChai: 'Split',
    Yu_ShangDuan_HeBing: 'Merge with Above',
    XuanZe: 'Select',
    XinZeng_ZuZhi: 'Add Organization',
    XiuGai_ZuZhi: 'Edit Organization',
    ZhuanJie: 'Referral',
    ZhangHao_MiMa: 'Account&Password',
    ShengMing_BiaoZheng: 'Vital Signs',
    JiaRu_ShiYanShi: 'Lab Admission Record',
    ShouYe: 'First',
    ShangYiYe: 'Previous',
    XiaYiYe: 'Next',
    QiTa: 'Other',
    ZanWu_QuTianJia: 'None yet, add',
    HeBing_HuanZhe_XinXi: 'Merge Patient Info',
    QueRen_HeBing: 'Confirm Merge',
    Xia_Yi_Bu: 'Next',
    TiaoGuo: 'Skip',
    FenPei_ZhenSuo: 'Clinics',
  },
}
